import { styled } from '@mui/material';

export const TitleWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  margin: '8px 0',
});
